import Sidebar from './Sidebar';
import Navbar from './Navbar';
import React from 'react';
import './style.css';
import Table from 'react-bootstrap/Table';

import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";


const EditTea = () => {

    const navigate = useNavigate();

    const [inputs, setInputs] = useState([]);

    const {id} = useParams();

    useEffect(() => {
        getUser();
    }, []);

    function getUser() {
        axios.get(`https://react-apis.dotlocalhost.com/teaShow.php/${id}`).then(function(response) {
            console.log(response.data);
            setInputs(response.data);
        });
    }

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values, [name]: value}));
    }
    const handleSubmit = (event) => {
        event.preventDefault();

        axios.put(`https://react-apis.dotlocalhost.com/teaShow.php/${id}/edit`, inputs).then(function(response){
            console.log(response.data);
            alert('Record have been updated succefully!');
            navigate('/Tea');
        });    
    }

    return(
        <div class="wrapper">
            <Sidebar/>
            <div id="content">
                <Navbar />

                <div className='ineerBody'>

                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>Edit Products</h3>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <Table cellSpacing="10">
                            <tbody>
                                <tr>
                                    <th>
                                        <label>Grade: </label>
                                    </th>
                                    <td>
                                        <input value={inputs.grade} className='form-control' type="text" name="grade" onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>Lot#: </label>
                                    </th>
                                    <td> 
                                        <input value={inputs.lot} className='form-control' type="text" name="lot" onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>Garden Name: </label>
                                    </th>
                                    <td>
                                        <input value={inputs.gardenName} type="text" name="gardenName" className='form-control' onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>Net Weight: </label>
                                    </th>
                                    <td>
                                        <input value={inputs.netWeight} type="text" name="netWeight" className='form-control' onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2" align ="right">
                                        <Link to={`/Tea`} style={{marginRight: "10px"}} class="btn btn-warning">Cancle Edit</Link>
                                        <button class="btn btn-success">Update</button>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </form>

                </div>

            </div>
        </div>
    )
}

export default EditTea;